module.exports = __webpack_public_path__ + "static/media/drive_car2.b99b7da2.jpg";